import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=1c710d29&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c710d29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c710d29')) {
      api.createRecord('1c710d29', component.options)
    } else {
      api.reload('1c710d29', component.options)
    }
    module.hot.accept("./Swiper.vue?vue&type=template&id=1c710d29&scoped=true", function () {
      api.rerender('1c710d29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/Swiper.vue"
export default component.exports